import appSettings from '../app-settings.json';
import { AuthSender } from './auth-sender';
import { StrRegistrationAPISender } from './str-registration-api-sender';

export const pciPaymentsApiSender = new StrRegistrationAPISender(appSettings.pciPaymentsApiDomain);
export const pciPaymentsAuthSender = new AuthSender(appSettings.pciPaymentsApiDomain);
